import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
/* API */
const { okta } = importer('APIs/auth', null)
const { forgotPassword } = okta
/* ACITONS */
const Actions = importer('Stores/AuthCustom/Actions')
/* STATE */
const { user } = importer('Stores/AuthCustom/Select', null)
/**
 *
 * @param {Object} param0
 * @param {String} param0.id
 * @param {String} param0.api_token
 * @param {Boolean} param0.sendEmail
 */
export default function * main ({ sendEmail }) {
  try {
    // id, api_token,
    const { oktaUserId, oktaDigitalId } = yield select(user)
    yield put(Actions.forgotPasswordLoading())
    const res = yield forgotPassword(oktaUserId, oktaDigitalId, sendEmail)
    yield put(Actions.forgotPasswordSuccess(res))
  } catch (error) {
    yield put(Actions.forgotPasswordFailure(error))
  }
}
